import React from 'react';
import tpl from '../templates/credit-limit.jsx';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';
import CreditsModel from '../../../Models/credits.m';
import {apiback} from '../../../../../config';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            model: {},
            mode: 'account_credit_limit_fop'
        };
    }

    componentWillMount() {
        fetch(apiback('ACCOUNT_CREDIT_CALC'))
            .then(res => res.json())
            .then(json => {
                const model = new CreditsModel(json.data, this.state.mode);
                this.setState({model});
            });
    }
}
